// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__1PKDE","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__21iym","gfeWrapper":"CalendarEvent_gfeWrapper__TDFL0"};